import React, { useContext, useState } from "react";
import _ from "lodash";
import Summaryutils from "../../utils/SummaryUtils";
import { Grid, List, ListItem } from "@material-ui/core";
import { Link } from "react-router-dom";
import { SummaryContext } from "../../context/SummaryContext";
import useStoreConfig from "../../hooks/useStoreConfig";
import { UserContext } from "../../context/UserContext";
import {parseAudioLayout} from "../processing/ProcessForm";
import AudioLayout from "../request/AudioLayout";
import RequestUtils from "../../utils/RequestUtils";
import "../../styles/summary.scss";
import FilesModal from "../modal/FilesModal";
import ConfigUtils from "../../utils/ConfigUtils";
import { PERMITTED_ROLES } from "../../constants/UserRoles";

const heading = [
  {
    label: "Job ID",
    fields: [
      {
        type: "id",
        value: "jobId",
      },
    ],
  },
  {
    label: "Request Name",
    fields: [
      {
        type: "text",
        value: "requestSummary.name",
      },
    ],
    width: "10px",
  },
];

const getHeaders = (role, jobType) => {
  const headersPart1 = [
    {
      label: "Request ID",
      fields: [
        {
          type: "text",
          value: "requestSummary.requestId",
        },
      ],
      specialHandling: "requestId"
    },
  
    {
      label: "Due Date",
      fields: [
        {
          type: "date",
          value: "dueDate",
        },
      ],
    },
  ];
  const headersPart2 = [
    {
      label: "Job Type",
      fields: [
        {
          type: "text",
          value: "jobType",
        },
      ],
      specialHandling: "jobType",
    },
    {
      label: "Source Type",
      fields: [
        {
          type: "text",
          value: "requests[0].sourceType",
        },
      ],
      specialHandling: "idType",
    },
    {
      label: "Department",
      fields: [
        {
          type: "text",
          value: "requestSummary.deptName",
        },
      ],
    },
    {
      label: "Status",
      fields: [
        {
          type: "text",
          value: "status",
        },
      ],
      specialHandling: "status",
    },
    {
      label: "Date Submitted",
      fields: [
        {
          type: "dateTime",
          value: "requestSummary.submittedDate",
        },
      ],
      width: "10px",
    },
    {
      label: "Created By",
      fields: [
        {
          type: "email",
          value: ["requests[0].requestor.fullName", "requests[0].requestor.email"],
        },
      ],
      width: "10px",
    },
    {
      label: "Assigned To",
      fields: [
        {
          type: "email",
          value: ["assignedTo.fullName", "assignedTo.email"],
        },
      ],
      width: "10px",
    },
  ];
  if (role === 'cr_api' || role === 'mediarequest' || ((role === 'globaladmin' || role === 'superadmin' || role === 'requestor' || role === 'ops') && (jobType === 'CONTENT_REQUEST_API' || jobType === 'MEDIA_REQUEST'))) {
    return [
      ...headersPart1,
      ...headersPart2,
      {
        label: "Content Type",
        fields: [
          {
            type: "text",
            value: "contentType",
          },
        ],
      },
    ];
  }

  return [
    ...headersPart1,
    {
      label: "Due Time",
      fields: [
        {
          type: "text",
          value: "dueTime",
        },
      ]
    },
    ...headersPart2,
    {
      label: "CC",
      fields: [
        {
          type: "cc",
          value: "requests[0].notificationList",
        },
      ],
      width: "10px"
    },
    {
      label: "Notes",
      fields: [
        {
          type: "text",
          value: "requests[0].notes",
        },
      ],
      width: "10px"
    }
  ]
}


const summaryHeader = (headersArr, data, title, icon, renderFn) => {
  return (
    <div
      className="w-100"
      key={"summary_container_" + title}>
      <div className="summaryHeaderTitleContainer">
        <label className="summaryHeaderTitle">
          {Summaryutils.hasEmptyFields(heading[0].fields, data)
            ? null
            : Summaryutils.getValue(heading[0].fields, data) +
              (Summaryutils.hasEmptyFields(_.get(heading[1], "fields"), data) ? "" : " :  " + Summaryutils.getValue(_.get(heading[1], "fields"), data))}
        </label>
      </div>
      <Grid container spacing={1} key={"summary_grid" + title}>
        {_.map(headersArr, (header, index) => {
            return Summaryutils.hasEmptyFields(header.fields, data) ? null : (
            <Grid item xs={4} key={header.label + index} className="p-0 mb-1">
              <div className="summaryFieldsDiv">
                <label className="summaryFieldsLabel">
                  {header.label + " :  "}
                </label>
                {_.includes(Summaryutils.getValue(header.fields, data), "\n")
                    ? Summaryutils.getValue(header.fields, data)
                        .split("\n")
                        .map((col, key) => (
                            <div key={"mailKey" + key} className={header.label === "Status" ? "summaryFieldsStatus" : "summaryFieldsInfo"}>
                              {_.includes(col, ".com") ? (
                                  <a style={{ color: "rgb(44, 130, 190)" }} href={"mailto:" + col}>
                                    {col}
                                  </a>
                              ) : (
                                <span>
                                  {col + "  "}
                                </span>
                              )}
                            </div>
                        ))
                    : renderFn(Summaryutils.getValue(header.fields, data), header, data)}
              </div>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export const renderHeaderTable = (headersArray, data, title, index, fileType = "") => {
  const isStitch = (title === 'Source' && _.get(data, "type") === "CompositeJobAsset");
  const sourceList = isStitch ? _.get(data, "simpleJobAssets") : [data];
  return (
    <div
      className="summaryBox"
      id={"summary_container_" + title + index}>
      <div className="summaryTitleContainer">
        <label className="summaryHeaderTitle">
          {!isStitch ? title : null}
        </label>
      </div>
      {isStitch ?
      <>
        <label className="summaryHeaderTitle">
          Stitched Source Assets:
        </label>
      </> : null}
      {_.map(sourceList, (source, idx) => {
        const fields = <RenderList
          headersList={headersArray}
          data={source}
          title={title}
          index={index}
          fileType={fileType}
        />
        return (isStitch ? (<div style={{ marginTop: idx > 0 ? '15px' : 0 }}>{fields}</div>) : fields);
      })}
      <AudioLayout
        audioLayout={parseAudioLayout(_.get(data, "audioLayout", null))}
        defaultValues={_.get(RequestUtils.getProcessType(data), "defaultAudioLayout", null)}
        audioMsg={_.get(RequestUtils.getProcessType(data), "defaultAudioMessage", null)}
        advanceOptions={_.get(data, "advancedOptions", false)}
        update={(channel, customAudioLayout) => {

        }}
        readOnly={true}
      />
    </div>
  );
};

export const RenderList = ({headersList, data, title, index, fileType = ""}) => {
  const [open,setOpen] = useState(false);
  
  return (
    <List className="p-0" key={"summary_list" + title + index}>
      {fileType ?
          <ListItem className="p-0" key={title+index}>
            <div className="summaryFieldsDiv">
              <label className="summaryFieldsLabel" style={{ color: "rgb(118, 221, 251)" }}>
                {/* remove hardcoding */}
                {title === 'Processing: WBD Screeners' ? 'WBD Screeners MP4 (1080)' : fileType}
              </label>
            </div>
          </ListItem>
      : null}
      {_.map(headersList, (header, key) => {
        if (header.fields[0].value === "packageName" && data["packageName"] === "filename.pkg") {
          return null;
        }
        const renderSummaryFieldsInfo = () => {
          if(_.includes(Summaryutils.getValue(header.fields, data), "\n")) {
            return Summaryutils.getValue(header.fields, data)
              .split("\n")
              .map((col, keyValue) => (
                <React.Fragment key={keyValue}>
                  {col}
                  <br />
                </React.Fragment>
              ))
          }else if(header.fields[0].type === "files") {
            return (
              <span className="fileModalWrapper">
                <span className="fileAnchor" onClick={() => { setOpen(true) }}>{Summaryutils.getValue(header.fields, data)}</span>
                <span>
                  <FilesModal
                    show={open}
                    files={data.files}
                    onClose={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setOpen(false);
                    }}
                  />
                </span>
              </span>
            )
          }else {
            return Summaryutils.getValue(header.fields, data)
          }
        }
        return Summaryutils.hasEmptyFields(header.fields, data) ? null : (
          <ListItem className="p-0" key={"summary_listItem" + header.label + index + key}>
            <div className="summaryFieldsDiv" style={{ whiteSpace: "pre-wrap", color: header.color && Summaryutils.getValue(header.fields, data) === 'Yes' ? header.color : 'inherit' }}>
              <label className="summaryFieldsLabel">
                {header.label ? (header.label + " : ") : ""}
              </label>
              <div className="summaryFieldsInfo">
                {renderSummaryFieldsInfo()}
              </div>
            </div>
          </ListItem>
        );
      })}
    </List>
  );
};

const SummaryHeader = () => {
  const { job } = useContext(SummaryContext);
  const { ConfigStore } = useStoreConfig();
  const { userRole } = useContext(UserContext);
  const renderFn = (val, header, data=null) => {
    let specialId = _.get(header, "specialHandling", "");
    switch (specialId) {
      case "status":
        let findRole = userRole !== "requestor" || job["jobType"] === "MEDIA_REQUEST" ? "ops" : userRole;
        let findValue = _.result(_.find(ConfigStore.statuses(), { role: findRole }), "statuses");
        let labelValue = _.find(findValue, ["value", val]);
        labelValue = _.get(labelValue, "label", "");
        return labelValue;
      case "idType":
        let sourceConfig = _.find(ConfigStore.sourceTypes(), ["value", val]);
        const sourceLocationFields = ConfigUtils.getSourceLocations();
        const newIdType = _.includes(PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES, userRole) 
        && sourceConfig.value === "MEDIA_SUPPLY_CHAIN" 
        ? _.find(sourceLocationFields, ["value", data.source.sourceLocation.newLocationSubType]) : null
        return _.get(newIdType, "label") ?? _.get(sourceConfig, "label", "");
      case "jobType":
        let idType = _.find(ConfigStore.jobTypeList(), ["value", val]);
        return _.get(idType, "label", "");
      case "requestId":
        return (
          <Link
          to={"/requestSummary?id=" + val}
          style={{ color: "#2C82C9" }}>
          {val}
        </Link>
        );
      default:
        return val;
    }
  };
  return _.isEmpty(job) ? null : summaryHeader(getHeaders(userRole, _.get(job, 'jobType')), job, "Request Details", null, renderFn);
};

export default SummaryHeader;
